import util from '../../common/util.js';
import { mapState as rootMapState } from 'pinia';
import { usePageStore, useUserStore } from '@/store';
import { mapState, mapActions } from '@/store/helpers';
import popMgr from '@/components/global/popMgr';
import saveDialog from './save-dialog';
import signLog from '../../components/sign-log';
import dispatchCondition from '@/components/search-result/_mixins/dispatch-condition';
import { getPlaceHolderMixin } from './_center-adaptor/index';
import { UPDATE_CONDITION, SET_TRANSLATED_PROPS, SORT_UPDATE_MUTATION } from '@/components/search-result/_store/types';
import * as TYPES from './_store/types';
import {
    ADD_KEYWORD_MUTATION,
    SET_GO_DETAIL,
    SET_LISTINGIDS_MUTATION,
    OTHER_URL_QUERY_MUTATION
} from '../md-search/_store/config';
import snapshotPop from '../../components/snapshot-save/index.js';
import {
    handleSuggestion,
    getFirstSuggestion
} from '@/common/search-suggestion.js';
import { fetchSuggestions, fetchFilterItemOptions } from './api.js';
import useSelectOption from '@/hooks/useSelectOption.js';
import { buildUrl } from '@/router/index.js';
import {
    conditionMapCenter,
    getPropsByConditionCenter,
    getIgnoreTags,
    getTagFilter,
    mapFormat,
    updateSearchListCenter
} from './_util/index.js'
import { numberFormat } from '../../common/format';
export default {
    emits: ['open', 'close'],
    i18next: {
        ns: 'md-search-bar'
    },
    props: ['cls', 'keywordsPlaceholder', 'keywordOnly'],
    mixins: [dispatchCondition(), getPlaceHolderMixin(true)],
    inject: {
        scrollTop: {
            type: Function,
            default: null
        },
        searchBarOnly: 'searchBarOnly',
        hideSearchBtn: 'hideSearchBtn',
        locationOnly: 'locationOnly',
        mlsId: 'mlsId',
        searchTheme: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            theme: '',
            keyword: '',
            keyWordSuggestion: [],
            doShowSuggestion: false,
            hasTag: false,
            collapse: true,
            // showMore: true,
            showMore: false,
            showMoreLoad: false,
            moreHeight: 0,
            searchData: {
                propertyConfigs: this.fetcherData?.propertyConfigs || [],
                more: this.fetcherData?.more || [],
                excludeLocation: this.fetcherData?.excludeLocation || []
            },
            activeSectionIndex: -1,
            isTitleUppercase: false,
            conditionMapCenter
        };
    },
    computed: {
        ...mapState([
            'conditionSort',
            'fetcherData',
            'keywords',
            'conditions',
            'recentlySearch',
            'mapCondition',
            'sort',
            'outsideFields',
            'showOutFields',
            'customizedCity',
            'otherUrlQuery',
            'translatedProps',
            'listingType',
            'moreLen',
            'mode',
            'searchParamsWithMap',
            'searchConfigMap',
            'allConditions',
            'otherSearchParams',
            'result',
            'aiRecommendLoading',
            'listingSortOptions'
        ]),
        ...mapState({
            layout: store => store.layout,
            gridOrListType: store => store.gridOrListType,
            composeLayout: store => store.layout === 'mixed',
            listingSource: store => store.listingSource,
            primaryKeysMap: store => store.primaryKeysMap
        }),
        ...rootMapState(useUserStore, ['hasLoggedIn']),
        ...rootMapState(usePageStore, {
            forCMS: store => store.forCMS,
            siteId: store => store.siteId,
            isSearchCenter: store => store.isSearchCenter,
            currencySymbol: store => store.currency.symbol,
            page: store => store.page || {},
            currencyRate: store => store.currencyRate
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        widget({ page }) {
            return page.widget;
        },
        showLocation() {
            return !!this.fetcherData?.location?.condition;
        },
        propertyConfigs() {
            return this.outsideFields.map(o => this.searchConfigMap[o])
        },
        selectedValues() {
            let selected =
                (this.conditions.selected && this.conditions.selected.value) ||
                this.selectedParams.selected;
            return selected ? selected.split(',').filter(val => !!val) : [];
        },
        saveAble() {
            return this.allConditions.length > 0 || this.searchBarOnly;
        },
        snapshotAbled() {
            return (this.keywords && this.keywords.length > 0) ||
                this.mapCondition.mapPath ||
                this.mapCondition.mapSearch ||
                this.mapCondition.mapRadius
                ? true
                : false;
        },
        selectedParams() {
            return (
                this.presetParams ||
                (this.fetcherData && this.fetcherData.selectedParams) ||
                {}
            );
        },
        searchList({ showOutFields, primaryKeysMap }) {
            return updateSearchListCenter({ primaryKeysMap, searchData: this.fetcherData.rawConf });
        },
        showMoreBtn() {
            return (
                this.searchList.reduce((memo, cur) => {
                    memo = [...memo, ...(cur.conditions || [])];
                    return memo;
                }, []).length > 0
            );
        },
        ignoreTags({ searchTheme, theme, outsideFields, isMobileSize }) {
            return getIgnoreTags({ theme: searchTheme || theme, outsideFields, isMobileSize });
        },
        tagFilter: getTagFilter,
        // composeLayout({ isCompose }) {
        //     return isCompose && isCompose.compose && !isCompose.onlyMap;
        // },
        cmpSnapshotHoverTip() {
            return this.$t('md-search-bar.pleaseSearchAValid');
        },
        count() {
            return this.result.counts;
        },
        formatCount() {
            return numberFormat(this.result.counts, true, 1);
        },
    },
    watch: {
        keyword() {
            this.keywordChange();
        },
        keywords() {
            this.keywordChange();
        },
        customizedCity() {
            if (!this.keyword.length) {
                this.keyWordSuggestion = this.customizedCity;
            }
        },
    },
    methods: {
        ...mapActions({
            updateConditionMutation: UPDATE_CONDITION,
            addKeywordMutation: ADD_KEYWORD_MUTATION,
            centerSetSwitch: TYPES.CENTER_SET_SWITCH,
            searchResetMutation: TYPES.SEARCH_RESET_MUTATION,
            setGoDetail: SET_GO_DETAIL,
            updateListingIdsMutation: SET_LISTINGIDS_MUTATION,
            otherUrlQueryMutation: OTHER_URL_QUERY_MUTATION,
            setTranslatedProps: SET_TRANSLATED_PROPS,
            updateRawConfOptions: TYPES.UPDATE_RAWCONF_OPTIONS,
            centerUpdateArrayCondition: TYPES.CENTER_UPDATE_ARRAY_CONDITION,
            centerUpdateInputBoxCondition:
                TYPES.CENTER_UPDATE_INPUT_BOX_CONDITION,
            centerUpdateKeywordCondition: TYPES.CENTER_UPDATE_KEYWORD_CONDITION,
            centerUpdateDefaultCondition: TYPES.CENTER_UPDATE_DEFAULT_CONDITION,
            setAiRecommendLoading: TYPES.SET_AI_RECOMMEND_LOADING,
            sortUpdateMutation: SORT_UPDATE_MUTATION
        }),
        // getConfigList(excludeField = []) {
        //     const configs = this.fetcherData.rawConf;
        //     configs.forEach(item => {
        //         const conditions = item.conditions;
        //         item.conditions = conditions.filter(
        //             o => !excludeField.includes(o.name)
        //         );
        //     });
        //     return configs;
        // },
        onTouchend(evt) {
            let active = document.activeElement;
            let domType = evt.target.tagName.toLowerCase();
            if (active && domType != 'input') {
                active.blur();
            }
        },
        filterOptions(args, force) {
            if (this.isMobileSize && args) {
                let argsWithoutEmpty = args.filter(arg => {
                    return arg.value;
                });
                if (argsWithoutEmpty.length < 6 || force) {
                    return argsWithoutEmpty;
                } else {
                    return args;
                }
            } else {
                return args;
            }
        },
        getSelectStyle(args) {
            if (this.isMobileSize && args) {
                let argsWithoutEmpty = args.filter(arg => {
                    return arg.value;
                });
                if (argsWithoutEmpty.length < 3) {
                    return 'two-column';
                }
                return 'select-list';
            } else {
                return '';
            }
        },

        toggleActiveSection(index) {
            this.activeSectionIndex =
                this.activeSectionIndex === index ? -1 : index;
        },

        //  deal with input when the input changes ， corresponding operation
        handleSuggestion() {
            if (!this.keyword) {
                if (this.keywords.length) {
                    this.keyWordSuggestion = [];
                } else {
                    this.keyWordSuggestion = this.customizedCity || [];
                }
            } else {
                //  to get suggestion data
                this.getSuggestion(this.keyword);
            }
        },
        inputClick(e) {
            if (!this.isMobileSize) {
                this.showMore = false;
                return this.showSuggestion();
            }
            if (this.keywordOnly) {
                return;
            }
            if (document.activeElement) {
                document.activeElement.blur();
            }
            this.$emit('open');
            e.preventDefault();
        },
        close() {
            this.$emit('close');
        },
        showSuggestionFn() {
            if (
                this.isMobileSize &&
                !this.keywordOnly
                // || (this.hasTag && this.keyword)
            ) {
                return;
            }
            this.collapse = false;
            this.doShowSuggestion = true;
        },
        mapFormat: mapFormat,
        hideSuggestion() {
            // AI 推荐加载过程中不关闭搜索面板
            if (this.aiRecommendLoading) {
                return;
            }
            this.doShowSuggestion = false;
            this.collapse = true;
        },

        //  Obtain suggestions
        async getSuggestion(value) {
            const params = {
                key: value,
                propertyId: 0,
                siteId: this.siteId,
                listingType: this.listingType
                // t: Date.now()
            };
            if (this.mlsId) {
                params.mlsId = this.mlsId;
            }
            let suggestionCount = ++this.suggestionCount;
            let ret = await fetchSuggestions.call(
                this,
                this.fetcherData?.location?.condition?.suggestionUrl,
                params
            );
            if (suggestionCount !== this.suggestionCount) {
                return;
            }
            this.keyWordSuggestion = handleSuggestion(
                ret,
                Object.keys(this.fetcherData?.location?.condition?.typeLabels)
            );
        },
        //  set up keyword corresponding
        selectSuggestion(type, key) {
            const data = { keyword: key, keywordType: type };
            const oldValue = util.deepClone(this.keywords);
            this.addKeywordMutation(data);
            this.dispatchConditions({
                init: false,
                kee: 'location',
                value: util.deepClone(this.keywords),
                oldValue
            });
            this.hideSuggestion();
            this.close();
            this.keyword = '';
        },
        handleEnterAndTrack() {
            if (window.siteAppVm) {
                window.siteAppVm.$EventBus.$emit('siteTrack', {
                    trackType: 'search-location-enter',
                    data: this.$refs.input
                });
            }
            this.handleEnter();
        },
        // Handle the enter event, and click the search icon
        handleEnter() {
            this.keyword = this.keyword.trim();
            if (!this.keyword) {
                return; 
            } // directly return without keyword
            // Perform exact search: Configure precise search and have keyword
            const isExactSearch = this.fetcherData.location.isExactSearch;
            if (isExactSearch) {
                const item = getFirstSuggestion(this.keyWordSuggestion);
                //  fuzzy search
                if (!item) {
                    return this.clickSuggestion('none', this.keyword); 
                }
                this.clickSuggestion(item.type, item.value); //  exact search
            } else {
                //  fuzzy search
                this.clickSuggestion('none', this.keyword);
            }
        },
        // Processing Click to select suggestion
        clickSuggestion(type, key) {
            // fixed bug: AM-216267
            const ids = this.pageLocation.query.ids;
            if (ids) {
                const otherUrlQuery = { ...this.otherUrlQuery };
                delete otherUrlQuery.ids;
                this.otherUrlQueryMutation(otherUrlQuery);
            }
            this.updateListingIdsMutation('');

            if (type === 'streetAddress') {
                this.setGoDetail(true);
            }
            this.selectSuggestion(type, key);
        },
        /**
         * 调用AI接口获取推荐条件
         * @param {String} naturalLanguage - 用户的自然语言查询文本
         * @param {Boolean} isHelpMerge - 是否帮助合并现有条件，默认false
         * @returns {Promise} AI推荐结果
         */
        async getAIRecommendation(naturalLanguage, isHelpMerge = false) {
            // 设置loading状态为true
            this.setAiRecommendLoading(true);
            
            try {
                // localStorage.setItem('useAiSearchMock', '1')
                const params = {
                    naturalLanguage: Array.isArray(naturalLanguage) 
                        ? naturalLanguage 
                        : [naturalLanguage],
                    isHelpMerge: isHelpMerge,
                    siteId: this.siteId,
                    type: 'all'
                };

                let response = await this.axiosIns.post(
                    '/open-api/api-site/ai/tools/listingCondition',
                    params
                );
                
                // 真实API返回格式: { status: { code: 0 }, data: { naturalLanguage: { searchCondition, sort }, conversationId } }
                if (response.data && response?.status?.code === 0) {
                    const { naturalLanguage: aiResult } = response.data;
                    
                    return  {
                        searchCondition: aiResult?.searchCondition || {},
                        sort: aiResult?.sort || null,
                    }
                } 
            } catch (error) {
                console.error('AI接口请求失败:', error);
            } finally {
                // 无论成功失败，都设置loading状态为false
                this.setAiRecommendLoading(false);
            }
        },
        /**
         * 验证排序值是否有效
         * @param {String} sortValue - AI返回的排序值
         * @returns {String} 有效的排序值（如果无效则返回默认值）
         */
        validateSortValue(sortValue) {
            // 从 store 获取 listingSortOptions
            const sortOptions = this.listingSortOptions || [];
            
            // 如果没有配置的排序选项，返回默认值 RELEVANCE
            if (!sortOptions || sortOptions.length === 0) {
                return 'RELEVANCE';
            }
            
            // 检查 sortValue 是否在可用选项中
            const isValid = sortOptions.some(option => option.value === sortValue);
            
            if (isValid) {
                return sortValue;
            } else {
                // 如果不匹配，使用第一个可用选项或默认值
                const defaultSort = sortOptions[0]?.value || 'RELEVANCE';
                return defaultSort;
            }
        },
        /**
         * AI推荐标签点击处理
         * @param {String} tag - AI推荐的查询文本
         */
        async changeRecommend(tag) {
            try {
                // 1. 调用AI接口获取推荐条件
                const conditions = await this.getAIRecommendation(tag);
                
                if (!conditions) {
                    console.error('AI recommendation interface returned failed', conditions);
                    return;
                }

                // 2. 转换AI返回的条件为中台格式
                const transformedConditions = this.transformAIResponseToConditions(
                    conditions.searchCondition
                );

                // 3. 根据 conditions 生成选择选项
                if (transformedConditions.conditions && Object.keys(transformedConditions.conditions).length > 0) {
                    // 构建 computedCondition 对象，用于 useSelectOption
                    const computedCondition = {};
                    Object.entries(transformedConditions.conditions).forEach(([fieldName, conditionData]) => {
                        const { value } = conditionData;
                        // 将值转换为字符串格式（与 getSelectOptionsWithPresetParams 保持一致）
                        if (Array.isArray(value)) {
                            computedCondition[fieldName.toLowerCase()] = value.join(',');
                        } else {
                            computedCondition[fieldName.toLowerCase()] = value;
                        }
                    });

                    // 调用 useSelectOption 获取选项
                    await useSelectOption({
                        fetcherData: this.fetcherData,
                        computedCondition: computedCondition,
                        context: this
                    });
                }

                // 4. 合并AI条件到store（批量处理，只触发一次搜索）
                this.mergeAIConditionsToStore(transformedConditions, true);

                // 5. 如果有排序条件，更新排序
                if (conditions.sort) {
                    // 验证 sort 值是否在 listingSortOptions 中存在
                    const validSort = this.validateSortValue(conditions.sort);
                    this.sortUpdateMutation(validSort);
                }

                // 6. AI推荐成功后才关闭搜索面板
                this.hideSuggestion();
                this.$refs.keywordSearchInput?.hideSuggestion();
                this.$refs.keywordSearchDashboard?.hideSuggestion();

                console.log('✅ AI recommendation conditions applied', {
                    original: conditions,
                    transformed: transformedConditions
                });

            } catch (error) {
                console.error('❌ AI recommendation processing failed', error);
                util.toast && util.toast('AI recommendation loading failed, please try again');
            }
        },
        
        /**
         * 将AI返回的条件转换为中台Store格式
         * @param {Object} aiConditions - AI返回的搜索条件
         * @returns {Object} 转换后的条件对象 {conditions, keywords}
         */
        transformAIResponseToConditions(aiConditions) {
            const transformed = {
                conditions: {},   // 普通条件
                keywords: []      // location条件
            };

            if (!aiConditions || typeof aiConditions !== 'object') {
                return transformed;
            }

            // 获取searchConfigMap，用于确定字段的inputType
            const { searchConfigMap } = this;

            // 遍历AI返回的每个条件
            Object.entries(aiConditions).forEach(([fieldName, fieldValue]) => {
                
                // 特殊处理：location字段
                if (fieldName === 'location') {
                    this.transformLocationCondition(fieldValue, transformed);
                    return;
                }

                // 跳过空值
                if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
                    return;
                }

                // ⚠️ 重要：将字段名转换为小写，保持与真实搜索一致
                const normalizedFieldName = fieldName.toLowerCase();

                // 获取字段配置（尝试原始名称和小写名称）
                const config = searchConfigMap[fieldName] || searchConfigMap[normalizedFieldName];
                
                if (config) {
                    // 有配置：使用配置的inputType
                    const inputType = config.inputType;
                    
                    transformed.conditions[normalizedFieldName] = {
                        value: this.normalizeConditionValue(fieldValue, inputType),
                        inputType: inputType,
                        aiRecommend: true  // 标记为AI推荐
                    };
                } else {
                    // 无配置：根据值类型推断inputType
                    const { value, inputType } = this.inferConditionType(fieldValue);
                    
                    transformed.conditions[normalizedFieldName] = {
                        value: value,
                        inputType: inputType,
                        aiRecommend: true
                    };
                }
            });

            return transformed;
        },
        
        /**
         * 转换location条件
         * @param {Object} locationValue - location对象，如 {city: ["New York"], county: ["LA"]}
         * @param {Object} transformed - 转换结果对象
         */
        transformLocationCondition(locationValue, transformed) {
            if (!locationValue || typeof locationValue !== 'object') {
                return;
            }

            // location的每个类型（city, county等）都要转换为keyword
            Object.entries(locationValue).forEach(([locationType, locations]) => {
                if (!Array.isArray(locations)) {
                    locations = [locations];
                }

                locations.forEach(location => {
                    if (location) {
                        transformed.keywords.push({
                            keyword: location,
                            keywordType: locationType,
                            aiRecommend: true  // 标记为AI推荐
                        });
                    }
                });
            });
        },
        
        /**
         * 标准化条件值
         * @param {*} value - 原始值
         * @param {String} inputType - 输入类型
         * @returns {*} 标准化后的值
         */
        normalizeConditionValue(value, inputType) {
            switch (inputType) {
            case 'multiSelect':
            case 'singleSelect':
            case 'suggestion':
                // 数组类型
                return Array.isArray(value) ? value : [value];
                
            case 'inputBox':
                // 字符串类型（通常是逗号分隔的范围值）
                return String(value);
                
            case 'checkBox':
                // 布尔类型
                return Boolean(value);
                
            case 'text':
            case 'keyWord':
                // 文本或关键词数组
                return Array.isArray(value) ? value : [value];
                
            default:
                // 默认保持原样
                return value;
            }
        },
        
        /**
         * 推断条件类型（当没有配置时）
         * @param {*} value - 条件值
         * @returns {Object} {value, inputType}
         */
        inferConditionType(value) {
            // 布尔值 -> checkBox
            if (typeof value === 'boolean') {
                return {
                    value: value,
                    inputType: 'checkBox'
                };
            }
            
            // 数组 -> multiSelect
            if (Array.isArray(value)) {
                return {
                    value: value,
                    inputType: 'multiSelect'
                };
            }
            
            // 包含逗号的字符串 -> inputBox（范围值）
            if (typeof value === 'string' && value.includes(',')) {
                return {
                    value: value,
                    inputType: 'inputBox'
                };
            }
            
            // 其他字符串/数字 -> text
            return {
                value: String(value),
                inputType: 'text'
            };
        },
        
        /**
         * 将AI条件合并到Store
         * @param {Object} transformedConditions - 转换后的条件
         * @param {Object} transformedConditions.conditions - 普通条件
         * @param {Array} transformedConditions.keywords - location条件
         * @param {Boolean} dispatchNow - 是否立即触发dispatch，默认true
         */
        mergeAIConditionsToStore(transformedConditions, dispatchNow = true) {
            const { conditions, keywords } = transformedConditions;

            // 记录旧状态（如果需要触发dispatch）
            const oldConditions = dispatchNow ? util.deepClone(this.conditions) : null;
            const oldKeywords = dispatchNow ? util.deepClone(this.keywords) : null;

            // 1. 合并普通条件（不立即触发dispatch）
            if (conditions && Object.keys(conditions).length > 0) {
                this.mergeNormalConditions(conditions, false);
            }

            // 2. 合并location条件（不立即触发dispatch）
            if (keywords && keywords.length > 0) {
                this.mergeLocationConditions(keywords, false);
            }

            // 3. 统一触发一次dispatch（如果需要）
            if (dispatchNow) {
                this.dispatchConditions({
                    init: false,
                    kee: 'ai-recommend',
                    source: 'ai',
                    value: {
                        conditions: util.deepClone(this.conditions),
                        keywords: util.deepClone(this.keywords)
                    },
                    oldValue: {
                        conditions: oldConditions,
                        keywords: oldKeywords
                    }
                });
            }
        },
        
        /**
         * 合并普通条件到Store
         * @param {Object} aiConditions - AI推荐的条件
         * @param {Boolean} dispatchNow - 是否立即触发dispatch，默认true
         */
        mergeNormalConditions(aiConditions, dispatchNow = true) {
            const updatedFields = [];

            Object.entries(aiConditions).forEach(([fieldName, conditionData]) => {
                const { value, inputType, aiRecommend } = conditionData;

                // 构建payload
                const payload = {
                    name: fieldName,
                    data: {
                        value: value,
                        inputType: inputType,
                        aiRecommend: aiRecommend  // 保留AI标记
                    }
                };

                // 根据inputType调用对应的mutation
                switch (inputType) {
                case 'multiSelect':
                case 'singleSelect':
                case 'suggestion':
                    this.centerUpdateArrayCondition(payload);
                    break;
                    
                case 'inputBox':
                    this.centerUpdateInputBoxCondition(payload);
                    break;
                    
                case 'keyWord':
                    this.centerUpdateKeywordCondition(payload, true);
                    break;
                    
                case 'checkBox':
                    // checkBox使用特殊的switch mutation
                    this.centerSetSwitch({
                        checked: value,
                        kee: fieldName,
                        aiRecommend: aiRecommend
                    });
                    break;
                    
                default:
                    this.centerUpdateDefaultCondition(payload);
                    break;
                }

                updatedFields.push(fieldName);
            });

            // 如果需要立即触发dispatch
            if (dispatchNow) {
                updatedFields.forEach(fieldName => {
                    const oldValue = util.deepClone(this.conditions[fieldName]);
                    this.dispatchConditions({
                        init: false,
                        kee: fieldName,
                        value: util.deepClone(this.conditions[fieldName]),
                        oldValue: oldValue
                    });
                });
            }

            return updatedFields;
        },
        
        /**
         * 合并location条件到Store（keywords）- 覆盖模式
         * @param {Array} aiKeywords - AI推荐的location条件
         * @param {Boolean} dispatchNow - 是否立即触发dispatch，默认true
         */
        mergeLocationConditions(aiKeywords, dispatchNow = true) {
            const oldKeywords = dispatchNow ? util.deepClone(this.keywords) : null;

            // 清空现有的keywords，使用覆盖模式
            // 注意：直接清空store中的keywords数组
            this.keywords.splice(0, this.keywords.length);

            // 添加新的AI推荐的keywords
            aiKeywords.forEach(keywordItem => {
                const { keyword, keywordType, aiRecommend } = keywordItem;

                // 使用addKeywordMutation添加新keyword
                this.addKeywordMutation({
                    keyword: keyword,
                    keywordType: keywordType,
                    aiRecommend: aiRecommend  // 保留AI标记
                });
            });

            // 如果需要立即触发
            if (dispatchNow) {
                const newKeywords = util.deepClone(this.keywords);
                
                this.dispatchConditions({
                    init: false,
                    kee: 'location',
                    value: newKeywords,
                    oldValue: oldKeywords
                });
            }

            return true;
        },
        updateTag(len) {
            this.hasTag = len > 0;
            if (
                !this.hasTag &&
                !/input/i.test(
                    (document.activeElement || document.body).tagName
                )
            ) {
                this.focusInput();
            }
        },
        expand() {
            this.collapse = false;
            this.showSuggestion();
            this.focusInput();
        },
        clickMoreOut() {
            this.showMore = false;
            util.enableScroll(true);
            // util.clickBlank();
        },
        clickMore(e) {
            e.outSideIgnore = this.clickMoreOut;

            if (!this.showMore) {
                this.hideSuggestion();
                if (util.isFunction(this.scrollTop) && !this.isMobileSize) {
                    this.scrollTop();
                    //  set up  more The height of the popup
                    setTimeout(() => {
                        this.moreHeight =
                            window.innerHeight -
                            this.$refs.searchMoreContainer.getBoundingClientRect()
                                .bottom -
                            2;
                    });
                } else {
                    this.moreHeight =
                        window.innerHeight -
                        this.$refs.searchMoreContainer.getBoundingClientRect()
                            .bottom -
                        2;
                }
            }
            this.showMoreLoad = true;
            this.showMore = !this.showMore;
        },
        updateCondition(payload) {
            // console.log('updateCondition payload 2 ====>>>', payload); // { kee: 'price', type: 'inputBox', value: 'xxx,xxx'}
            let { kee, value, type } = payload;
            payload = {
                name: kee,
                data: {
                    value,
                    inputType: type
                }
            };
            this.commitCenter(type, payload);
        },
        commitCenter(type, payload) {
            const oldValue = util.deepClone(this.conditions[payload.name]);
            switch (type) {
            case 'multiSelect':
            case 'singleSelect':
            case 'suggestion': {
                let { value } = payload.data;
                if (value && value.join('') === '') {
                    payload.data.value = []; 
                }
                this.centerUpdateArrayCondition(payload);
                break;
            }
            case 'inputBox':
                this.centerUpdateInputBoxCondition(payload);
                break;
            case 'keyWord':
                this.centerUpdateKeywordCondition(payload);
                break;
            default:
                this.centerUpdateDefaultCondition(payload);
                break;
            }
            const newValue = util.deepClone(this.conditions[payload.name]);
            this.dispatchConditions({
                init: false,
                kee: payload.name,
                value: newValue,
                oldValue
            });
        },
        toogledropdownOuter(arg) {
            this.showMore = false;
            this.toogledropdown(arg);
        },
        toogledropdown({ open, options, name }) {
            this.getOptionList({ name, options });
        },
        getOptionList({ name, options }) {
            if (options.length > 0) {
                return false;
            }
            fetchFilterItemOptions
                .call(this, {
                    siteId: this.siteId,
                    type: name
                })
                .then(data => {
                    this.updateRawConfOptions({ name, options: data });
                    // this.fetcherData.rawConf[0].conditions[7].options.push(...data);
                    // options.push(...data);
                })
                .catch(err => {
                    console.error(err);
                });
        },
        updateSelected(payload) {
            const oldValue = util.deepClone(this.conditions[payload.kee]);
            this.centerSetSwitch(payload);
            const newValue = util.deepClone(this.conditions[payload.kee]);
            this.dispatchConditions({
                init: false,
                kee: payload.kee,
                value: newValue,
                oldValue
            });
        },
        saveSearch(force) {
            force = force === true;
            if (
                !this.saveAble &&
                ((this.searchBarOnly && force) ||
                    (!this.searchBarOnly && !force))
            ) {
                return;
            }
            if (this.searchBarOnly && !force) {
                if (this.saveSearchDisabled) {
                    return; 
                }
                this.saveSearchDisabled = true;
                this.handleEnter(); // isExtend Exact search for
                setTimeout(() => {
                    this.saveSearchDisabled = false;
                }, 500);
                if (!this.page.wordPressSSR) {
                    this.$EventBus.$emit(
                        'change-url',
                        buildUrl({
                            name: 'listing',
                            query: Object.assign(
                                {},
                                this.otherSearchParams,
                                this.searchParamsWithMap,
                                // this.urlSearchParams,
                                this.mapCondition
                                // this.otherSearchParams
                            )
                        }),
                        'All Listing'
                    );
                }
                return;
            }
            if (this.hasLoggedIn) {
                this.openSaveSearch();
            } else {
                signLog.register({
                    registerTitle: this.$t('md-search-bar.saveThisSearch'),
                    registerSubTitle: this.$t(
                        'md-search-bar.saveSearchesSaveListings'
                    ),
                    onsuccess: (data) => {
                        if (!data?.isRegisterAgentLead) {
                            this.openSaveSearch();
                        }
                        return false;
                    }
                });
            }
        },
        openSaveSearch() {
            popMgr.create(saveDialog, {
                isTitleUppercase: this.isTitleUppercase,
                onHandleSave: this.handleSave
            });
        },
        async handleSave(searchName) {
            let params = await this.buildSaveParams();
            if (params.condition) {
                let { location } = JSON.parse(params.condition);
                if (
                    location &&
                    location.mapPath &&
                    params.mapSearch &&
                    params.rect
                ) {
                    params.mapSearch = false;
                }
            }
            const data = new FormData();
            data.append('saveName', searchName);
            data.append('searchCondition', JSON.stringify(params));
            this.axiosIns
                .post('/api-site/saveSearch', data)
                .then(({ data }) => {
                    util.toast(data);
                    this.$EventBus.$emit('siteTrack', {
                        listingId: 0,
                        trackType: 'save_search'
                    });
                });
        },
        transferDollarToTargetCurrency(condition, key) {
            //  base currency （ e.g. dollar ） Convert to the currency selected by the customer ,  Right now   multiply by the exchange rate
            const currencyRate = this.currencyRate || 1;
            if (condition[key] && condition[key].value) {
                let sourcePrice = condition[key].value.split(',');
                let lowPrice = '';
                let highPrice = '';
                if (sourcePrice[0] !== '' && sourcePrice[0] !== undefined) {
                    lowPrice = Math.round(
                        Number(sourcePrice[0]) * Number(currencyRate)
                    );
                }
                if (sourcePrice[1] !== '' && sourcePrice[1] !== undefined) {
                    highPrice = Math.round(
                        Number(sourcePrice[1]) * Number(currencyRate)
                    );
                }
                let priceArr = [lowPrice, highPrice];
                return priceArr.join(',');
            }
        },
        async buildSaveParams() {
            let params = Object.assign(
                {
                    listingType:
                        this.listingType === 'featured-listing'
                            ? 'custom-listing'
                            : this.listingType,
                    mode: this.mode,
                    sort: this.sort
                },
                this.otherSearchParams,
                this.searchParamsWithMap
            );
            if (this.listingType === 'featured-listing') {
                params.featureListingName = this.listingSource.replace(
                    /^\d\+/,
                    ''
                );
            }
            const mapCondition = this.mapCondition;
            let location = {};
            if (mapCondition.mapSearch) {
                const posArr = mapCondition.rect.split(',');
                let mapPathArr = [
                    { lat: posArr[0], lng: posArr[1] },
                    { lat: posArr[0], lng: posArr[3] },
                    { lat: posArr[2], lng: posArr[3] },
                    { lat: posArr[2], lng: posArr[1] }
                ];
                // const mapPath = JSON.stringify(mapPathArr);
                mapPathArr = mapPathArr.map(o => JSON.stringify(o));
                location.mapPath = mapPathArr;
            } else if (mapCondition.mapPath) {
                location.mapPath = mapCondition.mapPath;
                // params.mapPath = mapCondition.mapPath;
            }
            params.condition = params.condition
                ? JSON.parse(params.condition)
                : {};
            //  record currency
            console.log('params.condition', params.condition);
            !params.condition.location &&
                Object.keys(location).length > 0 &&
                (params.condition.location = location);
            params.condition = JSON.stringify(params.condition);
            return params;
        },
        async clickSaveSnapshot() {
            let location = '';
            if (this.keywords && this.keywords.length > 0) {
                location = this.keywords.map(k => k.keyword).join(',');
            } else if (this.mapCondition.mapPath) {
                location = 'Polygon search';
            } else if (this.mapCondition.mapRadius) {
                location = 'Radius search';
            } else if (this.mapCondition.mapSearch) {
                location = 'mapArea';
            }
            if (!location) {
                return; 
            }
            let params = await this.buildSaveParams();
            if (!params.mode) {
                delete params.mode; 
            } // in case of mode = ''
            delete params.listingType;
            const data = new FormData();
            data.append('searchCondition', JSON.stringify(params));
            const options = {
                params: data,
                location
            };
            if (this.hasLoggedIn) {
                snapshotPop.open(null, options);
            } else {
                snapshotPop.openAfterRegister(null, options);
            }
        },
        focusInput() {
            if (this.isMobileSize) {
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            }
        },
        reset() {
            this.searchResetMutation(this.tagFilter);
            this.dispatchConditions({
                init: false,
                kee: 'reset'
            });
        },
        handleInput($event) {
            this.keyword = $event.target.value;
            this.showSuggestion();
        },
        getItemOptions(o) {
            fetchFilterItemOptions
                .call(this, {
                    siteId: this.siteId,
                    type: o.initName || o.name
                })
                .then(data => {
                    this.updateRawConfOptions({ name: o.name, options: data || [] });
                });
        },
        getPropsByConditionCenter(data, inMore = false) {
            return getPropsByConditionCenter({ data, inMore, siteId: this.siteId, theme: this.theme })
        },
        isConditionType(type, values) {
            let ret =  values.some(k => type === k)
            return ret
        }
    },
    created() {
        // this.suggestionAxios = util.throttledRequest();
        this.keywordChange = util.debounce(this.handleSuggestion);
        this.showSuggestion = util.debounce(this.showSuggestionFn);
        this.keyWordSuggestion = this.customizedCity;
        // this.keyWordSuggestion = this.fetcherData.location.customizedCity;
        this.suggestionCount = 0;
    },
    mounted() {
        this.focusInput();
        var cb = () => {
            this.hideSuggestion();
        };
        document.addEventListener('click', cb);
        this.removeDocEvent = function() {
            document.removeEventListener('click', cb);
        };
        this.outsideFields.forEach(key => {
            const item = this.searchConfigMap[key];
            if (['multiSelect', 'singleSelect'].indexOf(item.inputType) > -1) {
                this.getItemOptions(item);
            }
        });
    },
    unmounted() {
        this.removeDocEvent();
    }
};
